import { render, staticRenderFns } from "./promoterList.vue?vue&type=template&id=629c20bd&scoped=true&"
import script from "./promoterList.vue?vue&type=script&lang=js&"
export * from "./promoterList.vue?vue&type=script&lang=js&"
import style0 from "./promoterList.vue?vue&type=style&index=0&id=629c20bd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "629c20bd",
  null
  
)

export default component.exports